
import { Card, CardContent } from "@/components/ui/card";
import { Package, AlertTriangle, RotateCcw, X } from "lucide-react";
import { EtsyProduct } from "@/hooks/useEtsyProducts";
import { getCachedOrders } from "@/utils/etsyCache";

interface ProductsHeaderProps {
  products: EtsyProduct[];
}

const ProductsHeader = ({ products }: ProductsHeaderProps) => {
  const totalProducts = products.length;
  const lowStockProducts = products.filter(product => 
    product.quantity !== undefined && product.quantity <= 5
  ).length;

  const totalRefunds = products.reduce((sum, product) => {
    return sum + (product.refundCount || 0);
  }, 0);

  const totalCancelled = products.reduce((sum, product) => {
    return sum + (product.cancelledCount || 0);
  }, 0);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Total Products</p>
              <p className="text-2xl font-bold text-gray-900">{totalProducts}</p>
            </div>
            <Package className="h-8 w-8 text-blue-600" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Total Refunds</p>
              <p className="text-2xl font-bold text-gray-900">{totalRefunds}</p>
            </div>
            <RotateCcw className="h-8 w-8 text-orange-600" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Total Cancelled</p>
              <p className="text-2xl font-bold text-gray-900">{totalCancelled}</p>
            </div>
            <X className="h-8 w-8 text-red-600" />
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Low Stock</p>
              <p className="text-2xl font-bold text-gray-900">{lowStockProducts}</p>
            </div>
            <AlertTriangle className="h-8 w-8 text-orange-600" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProductsHeader;
